import React, {useEffect, useState} from 'react';


export const useFormValidation = (initialState, callback) => {
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (isSubmitting) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                callback(); // funkcija koju prosledjujemo da se izvrsi ako form ispunjava sve uslove (nema gresaka)
                setSubmitting(false);
            } else {
                setSubmitting(false);
            }
        }

    }, [errors]);

    const handleChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setValues({...values, [event.target.name]: event.target.files[0]});
        } else if (event.target.type === 'checkbox') {
            setValues({...values, [event.target.name]: event.target.checked});
        } else {
            setValues({...values, [event.target.name]: event.target.value});
        }
    };

    const resetForm = (resetObject) => {
        setValues(resetObject);
    };

    const handleBlur = () => {
        const validationErrors = validateInputField(values);
        console.log("handling blur errors", validationErrors);
        setErrors(validationErrors);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validateInputField(values);
        setErrors(validationErrors);
        setSubmitting(true);
    };

    return {handleChange, handleSubmit, handleBlur, resetForm, errors, isSubmitting, values};
};

const inputFieldsNames = {
    email: 'email',
    password: 'password',
    visitedMoreThanValue: 'visitedMoreThanValue',
    visitedLessThanValue: 'visitedLessThanValue',
    spentMoreThanValue: 'spentMoreThanValue',
    spentLessThanValue: 'spentLessThanValue',
    validFrom: 'validFrom',
    validTo: 'validTo',
    campaignsList: 'campaignsList',
    voucherType: 'voucherType',
    offerValue: 'offerValue',
};

const regexPatternsFor = {
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    campaignsList: /[!@#$%^&*()+\-=\[\]{};':"\\|.<>\/?\s]+/,
};

const validateInputField = (values) => {
    let errors = {};
    const valuesPropertyName = Object.keys(values);
    valuesPropertyName.forEach(propName => {
        switch (propName) {
            case inputFieldsNames.email: {
                if (!values.email) {
                    errors.email = 'Required';
                } else if (!regexPatternsFor.email.test(values.email)) {
                    errors.email = 'Invalid email address';
                }
                break;
            }
            case inputFieldsNames.offerValue: {
                if (!values.offerValue) {
                    errors.offerValue = 'Required';
                }
                break;
            }
            case inputFieldsNames.password: {
                if (!values.password) {
                    errors.password = 'Required';
                } else if (values.password.length < 6) {
                    errors.password = 'Password must be at lest 6 characters';
                }
                break;
            }
            case inputFieldsNames.visitedMoreThanValue: {
                if (!values.visitedMoreThanValue) {
                    errors.visitedMoreThanValue = 'Morate podesiti vrednost za minimalni broj poseta';
                } else if (parseInt(values.visitedMoreThanValue) < 0) {
                    errors.visitedMoreThanValue = 'Vrednost je negativna unesita validnu vrednost';
                }
                break;
            }
            case inputFieldsNames.visitedLessThanValue: {
                if (parseInt(values.visitedLessThanValue) < 0) {
                    errors.visitedMoreThanValue = 'Vrednost je negativna unesita validnu vrednost';
                }
                break;
            }
            case inputFieldsNames.spentMoreThanValue: {
                if (!values.spentMoreThanValue) {
                    errors.spentMoreThanValue = 'Morate podesiti vrednost za minimalnu potrosnju musterije';
                } else if (parseInt(values.spentMoreThanValue) < 0) {
                    errors.spentMoreThanValue = 'Vrednost je negativna unesita validnu vrednost';
                }
                break;
            }
            case inputFieldsNames.spentLessThanValue: {
                if (parseInt(values.spentLessThanValue) < 0) {
                    errors.spentLessThanValue = 'Vrednost je negativna unesita validnu vrednost';
                }
                break;
            }
            case inputFieldsNames.campaignsList: {
                const list = values.campaignsList && values.campaignsList.toString().split(',');
                if(list.length > 10000) {
                    errors.campaignsList = 'Can not be sent to more than 10 000 users at once. Please split you data set.';
                }
                if (list.length){
                    let count = 0;
                    list.forEach(id => {
                        if(regexPatternsFor.campaignsList.test(id.toString().trim())) {
                            count +=1;
                        }
                    });
                    if (count > 0) {
                        errors.campaignsList = 'Values for list of UIDs should be comma separated.';
                    }
                }
                break;
            }
            case inputFieldsNames.voucherType: {
                if (values.voucherType.length !== 0 && values.voucherType.length !== 13) {
                    errors.voucherType = 'Voucher id must be 13 characters. Now it is ' + values.voucherType.length;
                }
                break;
            }
            case inputFieldsNames.validFrom: {
                break;
            }
            case inputFieldsNames.validTo: {
                break;
            }
            default: {
            }
        }
    });
    return errors;
};











